<template>
  <div>
    <DeniedPrs/>
  </div>
</template>
  
  <script>
  // @ is an alias to /src
  import DeniedPrs from '@/components/DeniedPrs.vue'
  
  export default {
    name: 'penidng-approval-view',
    components: {
      DeniedPrs
    }
  }
  </script>
  